import { ExceptionApis, ExceptionCodes } from './StatusCodes';
// IMAGE
export const NEW_LOGIN_LOGO = require('@/public/static/images/img_login_logo.png').default;
export const MY_PROFILE_IMAGE = require('@/public/static/images/img_my_profile.png').default;
export const CREATOR_DEFAULT_IMAGE = require('@/public/static/images/img_creator_default.png').default;
export const PRODUCTION_IMAGES = {
    NA7017: require('@/public/static/images/img_package_01.png').default,
    NA00007017: require('@/public/static/images/img_package_01.png').default,
    NA7246: require('@/public/static/images/img_package_02.png').default,
    NA00007246: require('@/public/static/images/img_package_02.png').default,
};
export const EVENT_WINNER_IMAGE = require('@/public/static/images/img_raffle.png').default;
export const APP_INSTALL = require('@/public/static/images/popup_img.png').default;
export const ICO_CREATOR_HOME = require('@/public/static/images/ico_creator.png').default;
export const ICO_CREATOR_HOME_WHITE = require('@/public/static/images/ico_creator_white.png').default;
// LABEL
export const EXCEPT_NAVIGATION = [
    'login',
    'video',
    'tutorial',
    '/setting/notices/[id]',
    '599',
    'join_sktevent',
    '/present/recieve/[id]',
    '/making/ai',
];
// MESSAGE
export const DEFAULT_ERROR_MESSAGE = '일시적인 장애로 페이지를 표시할 수 없습니다. 잠시 후 다시 시도해 주세요.';
export const TIMEOUT_MESSAGE = '일시적으로 서비스 연결이 지연되고 있습니다. 잠시 후 다시 시도해 주세요.';
// NUMBER
export const COUPON_LENGTH = 8;
export const DEFAULT_LIST_SIZE = 20;
export const DEFAULT_TIMEOUT = 30000;
export const HALF_HOUR = 30 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const ONE_MINUTE = 60 * 1000;
export const ONE_DAY = 60 * 60 * 1000 * 24;
export const VALID_SMS_SECONDS = 180;
export const DEFAULT_UPLOADING_DURATION_FOR_APP = 15;
export const DEFAULT_UPLOADING_DURATION_MIN = 3;
export const DEFAULT_UPLOADING_DURATION_MAX = 60;
export const DEFAULT_UPLOADING_SIZE_MAX_WIDTH = 1920;
export const DEFAULT_UPLOADING_SIZE_MAX_HEIGHT = 1080;
export const DEFAULT_UPLOADING_SIZE_MIN_WIDTH = 640; // VGA 최소 width
export const DEFAULT_UPLOADING_SIZE_MIN_HEIGHT = 480; // VGA 최소 height
export const DEFAULT_UPLOADING_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
export const UPLOADING_TICK = 0.1;
export const AUTO_COLORING_SEARCH_MAX = 100;
// REGIX
export const PHONE_NUMBER_REGEX = /^01([0|1|6-9])\d{7,8}$/;
export const ONLY_WORD_AND_NUMBER_REGEX = /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9\s\u318D\u119E\u11A2\u2025\u00B7\uFE55\u4E10]*$/;
export const COUPON_REGEX = /^[a-zA-Z0-9]{0,8}$/;
export const SPECIAL_CHAR_REGEX = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;
// URL
export const VOICE_COLORING_URL_SKT = 'https://www.tcoloring.com';
export const VOICE_COLORING_URL_KT = 'https://ringtoyou.kt.com/ ';
export const VOICE_COLORING_URL_LGU = 'https://musicbellring.uplus.co.kr/';
// export const VOICE_COLORING_URL_LGU_APP =
//   'https://www.musicon.co.kr/if/landing.jsp?scheme=ubellring&package_name=com.lgu&intent=top100/'; TODO: 다음배포에서 삭제
export const VOICE_COLORING_APP_INTENT = 'intent://tcoloring?linktype=dlink&dlink=https%3A%2F%2Fwww.tcoloring.com%2Findex.jsp;#Intent;scheme=com.real.tcolorring;package=com.real.tcolorring;S.market_referrer=linktype=dlink&dlink=https%3A%2F%2Fwww.tcoloring.com%2Findex.jsp;end';
export const ANDROID_PACKAGE = 'com.sktelecom.vcoloring';
export const MARKET_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
export const BUSINESS_INFO_URL = 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048137225';
export const APP_LINK = process.env.NEXT_PUBLIC_MODE === 'QA' ? 'https://www-qa.vcoloring.com' : 'https://www.vcoloring.com';
export const DEEP_LINK = process.env.NEXT_PUBLIC_MODE === 'QA' ? 'https://vcoloring.onelink.me/Ac4O' : 'https://vcoloring.onelink.me/vD4y';
export const DEEP_LINK_MARKET = `https://vcoloring.onelink.me/XVBL/app`;
export const FIREBASE_SHORT_API = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${process.env.NEXT_PUBLIC_FB_API_KEY}`;
export const APPS_FLYER_LINK = 'https://app.appsflyer.com';
export const APP_ONE_LINK = 'https://vcoloring.onelink.me/Ac4O';
// VALUE
export const NO_DISPLAY_ERROR_CODE_LIST = Object.values(ExceptionCodes);
export const NO_DISPLAY_ERROR_API_LIST = Object.values(ExceptionApis);
// VARIABLE
export const NONE = 'none';
export const DISABLED_POPUP_KEY = 'vrbt-disabled-popups';
export let IS_FETCHING_REFRESH = false;
// Subscribed service type
export const VCOLORING = 'VCOLORING';
export const VBIZRING = 'VBIZRING';
// LocalStorage key
export const SEARCH_KEY = 'vrbt-searches';
export const SEARCH_AUTO_COLORING_KEY = 'vrbt-searches-auto-coloring';
export const SEARCH_AUTO_COLORING_STORE_KEY = 'vrbt-searches-auto-coloring-store';
export const DISABLED_COUPON = 'vrbt-disabled-coupon';
export const DISABLED_UPLOAD_UGC_GUIDE = 'vrbt-disabled-upload-ugc-guide';
export const DISABLED_UPLOAD_TIME_GUIDE = 'vrbt-disabled-upload-time-guide';
// CUSTOM_EVENT
export const POPUP_INITIAL_OPEN = 'vrbt-popup-initial-open';
export const POPUP_ALL_CLOSE = 'vrbt-popup-all-close';
export const PROMOTION_AGREE = {
    overFourteenAgree: true,
    personalInfoCollectionAndUsageAgree: true,
    personalInfoProcessingAndConsignmentAgree: true,
};
